import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import router from "@/router";
  import store from "@/store";
  import { UserInterface } from "@/types/UserInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import { UserRoles } from "@/enums/UserRoles";
  import { EstateType } from "@/enums/EstateType";
  import { getFirstLastName } from "@/helpers/user";
  import AddLawyerToEstateModal from "@/components/ui/modals/AddLawyerToEstateModal.vue";
  import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import { formatPrice } from "@/helpers/transformation/price";
  import estateApi from "@/services/api/estateApi";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import { useToast } from "vue-toastification";
  import InputFile from "@/components/ui/input/InputFile.vue";
  import SelectImportedListingModal from "@/components/ui/modals/SelectImportedListingModal.vue";
  import { ImportedListingInterface } from "@/types/ImportedListingInterface";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstate',
  setup(__props, { expose: __expose }) {
  __expose();

  const importedListingData = ref([]);
  const fileInputRef = ref<HTMLInputElement | null>(null);

  const toast = useToast();
  const { userId, estateId } = router.currentRoute.value.params;
  const user = ref<UserInterface | null>(null);
  const estate = ref<EstateInterface | null>(null);
  const showAddLawyerModal = ref(false);
  const showConfirmDeleteLawyerModal = ref(false);
  const lawyerName = computed(() => {
    if (estate.value?.lawyerId) {
      const { firstName, lastName } = estate.value.lawyerId;

      return `${firstName} ${lastName}`;
    }

    return "";
  });
  const isActiveEstate = ref(false);
  const isSelectImportedModalOpen = ref(false);

  onMounted(() => {
    store.dispatch("user/getUser", userId).then((res) => {
      user.value = res.data;
    });
    fetchEstate();
  });

  const tabs = computed(() => {
    const baseTabs = [
      { label: "stages" },
      { label: "documents" },
      { label: "map" },
      { label: "new-interactive-map" },
    ];

    // Add residential community specific tabs
    if (estate.value?.type === EstateType.RESIDENTIAL_COMMUNITY) {
      baseTabs.push(
        { label: "home-designs" },
        { label: "inclusions" },
        { label: "interior-colours" },
        { label: "optional-upgrades" }
      );
    }

    return baseTabs;
  });

  const currentTab = computed(() => {
    const lastSegment = router.currentRoute.value.path.split("/").pop();

    return tabs.value.find((tab) => tab.label === lastSegment);
  });
  const onGetLawyerId = (lawyerId: string) => {
    showAddLawyerModal.value = false;
    updateEstate({ lawyerId });
  };
  const toTab = (tab: string) => {
    if (currentTab.value && currentTab.value.label !== tab) {
      const segments = router.currentRoute.value.path.split("/");

      segments[segments.length - 1] = tab;
      router.push(segments.join("/"));
    }
  };
  const onChangeActiveEstate = () => {
    estateApi
      .changeEstateActive({
        estateId: String(estateId),
        isActive: isActiveEstate.value,
      })
      .then(() => {
        const message = isActiveEstate.value
          ? "The estate is active now."
          : "The estate is switched to draft.";

        toast.success(message);
      })
      .catch((error) => {
        isActiveEstate.value = false;
        toast.error(error.response?.data?.message);
      });
  };
  const onRemoveLawyer = () => {
    if (estate.value) {
      estateApi.unassignLawyer(estate.value._id).then(fetchEstate);
    }
  };
  const fetchEstate = () => {
    store.dispatch("estate/getEstate", estateId).then((res) => {
      estate.value = res.data;
      isActiveEstate.value = res.data.isActive;
    });
  };
  const updateEstate = (props: any) => {
    store
      .dispatch("estate/updateEstate", { id: estateId, data: props })
      .then((response) => {
        estate.value = response.data;
        router.push({
          name: "AdminEstate",
          params: { userId, estateId },
        });
      });
  };

  const createFormData = (event: InputEvent) => {
    const files = (event.target as HTMLInputElement).files as FileList;
    const formData = new FormData();

    formData.append("file", files[0]);
    return formData;
  };

  const onImportListing = (event: InputEvent) => {
    const formData = createFormData(event);

    store
      .dispatch("listing/parseXmlToListings", {
        estateId,
        landownerId: userId,
        data: formData,
      })
      .then((res) => {
        importedListingData.value = res.data;
        isSelectImportedModalOpen.value = true;
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error(
            "Error while uploading file - please check the file format and the data inside the file"
          );
          return;
        }

        toast.error("Something went wrong, try later");
      });
  };

const __returned__ = { importedListingData, fileInputRef, toast, userId, estateId, user, estate, showAddLawyerModal, showConfirmDeleteLawyerModal, lawyerName, isActiveEstate, isSelectImportedModalOpen, tabs, currentTab, onGetLawyerId, toTab, onChangeActiveEstate, onRemoveLawyer, fetchEstate, updateEstate, createFormData, onImportListing, computed, onMounted, ref, SwitchComponent, get router() { return router }, get store() { return store }, get UserInterface() { return UserInterface }, get EstateInterface() { return EstateInterface }, get UserRoles() { return UserRoles }, get EstateType() { return EstateType }, get getFirstLastName() { return getFirstLastName }, AddLawyerToEstateModal, ConfirmDeleteModal, get formatPrice() { return formatPrice }, get estateApi() { return estateApi }, ToggleButton, get useToast() { return useToast }, InputFile, SelectImportedListingModal, get ImportedListingInterface() { return ImportedListingInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})